import { render, staticRenderFns } from "./VerticalCardThreeLevelIcon.vue?vue&type=template&id=635dc5b6&scoped=true&"
import script from "./VerticalCardThreeLevelIcon.vue?vue&type=script&lang=js&"
export * from "./VerticalCardThreeLevelIcon.vue?vue&type=script&lang=js&"
import style0 from "./VerticalCardThreeLevelIcon.vue?vue&type=style&index=0&id=635dc5b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635dc5b6",
  null
  
)

export default component.exports